module.exports = __webpack_public_path__ + "img/zw.b1ba4bd0.png";